export default "__VITE_ASSET__B2uzxjC0__"